import { Box, BoxProps, Button, styled } from '@mui/material';

export const UpdatePersonalInfoFormContainer = styled((props: BoxProps) => (
  <Box component="form" {...props} />
))(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  width: '100%',
}));

export const UpdatePersonalInfoFormSubmitButton = styled(Button)(
  ({ theme }) => ({
    marginBottom: theme.spacing(1.5),
  }),
);

export const ButtonRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  width: '100%',
}));
